import { lazy } from "react";

export const VouchersAsync = lazy(() => import("./VouchersTable"));
